(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.adjustCollapse = adjustCollapse;
function adjustCollapse(element) {
    var breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 768;

    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var elements = document.querySelectorAll(element);

    elements.forEach(function (desc) {
        var previousElement = desc.previousElementSibling;
        var toggleElement = previousElement && previousElement.getAttribute('data-toggle') === 'collapse' ? previousElement : null;

        if (width > breakpoint) {
            desc.classList.add('in');
            if (toggleElement) {
                toggleElement.classList.remove('collapsed');
            }
        } else {
            desc.classList.remove('in');
            if (toggleElement) {
                toggleElement.classList.add('collapsed');
            }
        }
    });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closeModalSendEmailOrderTracking = closeModalSendEmailOrderTracking;
exports.priceCalculOALR = priceCalculOALR;
exports.toolsBoxCall = toolsBoxCall;
exports.pageOrder = pageOrder;
exports.zoomAccessoryOrderPage = zoomAccessoryOrderPage;
exports.paymentPage = paymentPage;
exports.loadTemplate = loadTemplate;
exports.uploadInformationAccordion = uploadInformationAccordion;
exports.dynamicPriceProductCard = dynamicPriceProductCard;
exports.selectsStatutNotification = selectsStatutNotification;
exports.verifSelectInputStatutNotification = verifSelectInputStatutNotification;
exports.inputsStatutNotification = inputsStatutNotification;
exports.showFloristSchedules = showFloristSchedules;
exports.updateFloristDeliveryLocationValue = updateFloristDeliveryLocationValue;
exports.prefillAddressFields = prefillAddressFields;
exports.updateProductQuantityOnOrderPage = updateProductQuantityOnOrderPage;
exports.updateAccessoryQuantityOnOrderPage = updateAccessoryQuantityOnOrderPage;

var _utils = require('./utils');

if (window.jQuery === undefined) {
    window.jQuery = window.$ = require('jquery');
}

function priceCalcul(currencyCurrent) {

    if ($('.product-data .value[data-attr="summary-product-amount"]').length) {
        priceCalculOALR(currencyCurrent);
        return false;
    }

    var accessoriesPrice = 0;
    var servicesPrice = 0;
    var stickersPrice = 0;
    var totalProductPrice = 0;
    var separator = (0, _utils.getSeparator)(currencyCurrent);
    var currency = (0, _utils.getCurrency)(currencyCurrent);
    var $deliveryPriceId = $('#delivery-price');
    var $discountPriceId = $('#discount-price');
    var $specialDeliveryPrice = $('#special-delivery-price');
    var $companyDiscount = $('#company-discount');
    var productPrices = '#form_order_checkout_productPrices';
    var deliveryPrice = parseFloat($deliveryPriceId.attr('data-delivery-price'));
    var productListElement = document.querySelector('.js-order-checkout-product-list');

    var discountPrice = $discountPriceId.attr('data-discount-price') ? parseFloat($discountPriceId.attr('data-discount-price')) : 0;

    var discountDelivery = $specialDeliveryPrice.attr('data-special-delivery-price') ? parseFloat($specialDeliveryPrice.attr('data-special-delivery-price')) : 0;

    var companyDiscount = $companyDiscount.attr('data-company-discount-price') ? parseFloat($companyDiscount.attr('data-company-discount-price')) : 0;

    $('input[id*="accessory-"]').each(function () {
        if ($(this).is(':checked')) {
            accessoriesPrice = accessoriesPrice + parseFloat($(this).attr('data-acc-price'));
        }
    });

    var accessoryInputs = document.querySelectorAll('.js-accessory-quantity');
    if (accessoryInputs.length > 0) {
        accessoryInputs.forEach(function (input) {
            if (input.value > 0) {
                accessoriesPrice += parseFloat(input.getAttribute('data-acc-price') * parseFloat(input.value));
            }
        });
    }

    document.querySelectorAll('.js-service').forEach(function (service) {
        if (service.checked && service.dataset.accPrice > 0) {
            servicesPrice = servicesPrice + parseFloat(service.dataset.accPrice);
        }
    });
    checkAndDisplayServiceTotalLine();

    document.querySelectorAll('.js-custom-sticker').forEach(function (sticker) {
        if (sticker.checked && sticker.dataset.accPrice > 0) {
            stickersPrice = stickersPrice + parseFloat(sticker.dataset.accPrice);
        }
    });

    var accessoryTotalLines = document.querySelectorAll(".js-order-product-accessory-line");
    accessoryTotalLines.forEach(function (accessoryTotalLine) {
        if (accessoryTotalLine) {
            if (accessoriesPrice > 0) {
                accessoryTotalLine.classList.remove('hidden-line');
            } else {
                accessoryTotalLine.classList.add('hidden-line');
            }
        }
    });

    checkAndDisplayAccessoryLines();

    /* Order is a cart and can have multiple products */
    if (productListElement && productListElement.dataset.iscart === '1') {
        totalProductPrice = 0;
        document.querySelectorAll('.js-order-product').forEach(function (block) {
            var quantity = parseInt(block.querySelector('.js-order-product-quantity').dataset.productQuantity);
            var sizeElement = block.querySelector('.js-order-select-size');
            var unitPrice = void 0;
            if (sizeElement.tagName === 'SELECT') {
                unitPrice = parseFloat(sizeElement.querySelector('option:checked').dataset.sizePrice);
            } else {
                unitPrice = parseFloat(sizeElement.dataset.sizePrice);
            }
            totalProductPrice += quantity * unitPrice;
        });
    } else {
        var totalProductPriceDIY = document.querySelector(".js-total-diy");
        if (totalProductPriceDIY) {
            totalProductPrice = parseFloat(totalProductPriceDIY.dataset.totalProductPrice);
        } else {
            var unitProductPrice = parseFloat(window.jQuery(productPrices + ' option:selected').attr('data-size-price')) || parseFloat(window.jQuery(productPrices).attr('data-size-price'));
            var productQuantityElement = document.querySelector('.js-order-product-quantity');
            var productQuantity = productQuantityElement ? parseInt(productQuantityElement.dataset.productQuantity, 10) : 1;
            totalProductPrice = unitProductPrice * productQuantity;
        }
    }

    var totalPrice = totalProductPrice + accessoriesPrice + servicesPrice + stickersPrice + deliveryPrice - discountPrice - discountDelivery - companyDiscount;

    $('[data-switch="product-price"]').text(totalProductPrice.toFixed(2).replace('.', separator) + '\xa0' + currency);
    $('[data-switch="accessories-price"]').text(accessoriesPrice.toFixed(2).replace('.', separator) + '\xa0' + currency);
    if (document.querySelector('[data-switch="services-price"]')) {
        document.querySelector('[data-switch="services-price"]').textContent = servicesPrice.toFixed(2).replace('.', separator) + '\xa0' + currency;
    }

    if (document.querySelector('[data-switch="custom-stickers-price"]')) {
        document.querySelector('[data-switch="custom-stickers-price"]').textContent = stickersPrice.toFixed(2).replace('.', separator) + '\xa0' + currency;
    }

    $('[data-switch="total-price"]').text(totalPrice.toFixed(2).replace('.', separator) + '\xa0' + currency);
}

function closeModalSendEmailOrderTracking() {
    var buttonCloseSendMailConfirmationSelfcare = document.getElementById('close-modal-confirmation-selfcare');
    var backGroundModal = document.getElementById('background-modal-confirmation-send-mail-selfcare');
    var modalConfirmationSendMailSelcare = document.getElementById('modal-confirmation-mail-selfcare');
    if (buttonCloseSendMailConfirmationSelfcare !== null) {
        buttonCloseSendMailConfirmationSelfcare.addEventListener('click', function () {
            backGroundModal.style.display = 'none';
            modalConfirmationSendMailSelcare.style.display = 'none';
        });
    }
}

function updateHtmlPriceOALR(el, value, currencyCurrent) {
    var strAmount = value.toFixed(2).replace('.', (0, _utils.getSeparator)(currencyCurrent));
    el.childNodes[0].firstChild.textContent = (0, _utils.getCurrency)(currencyCurrent) + Math.trunc(strAmount);
    el.childNodes[0].lastChild.textContent = strAmount.substr(-3, 3);
}

function priceCalculOALR(currencyCurrent) {

    var $summaryOrderAmount = $('*[data-attr="summary-order-amount"]');
    var $summaryAccessoriesAmount = $('*[data-attr="summary-accessories-amount"]');
    var $summaryTaxAmount = $('*[data-attr="summary-tax-amount"]');
    var $inputsAccessory = $('input[id*="accessory-"]');
    var separator = (0, _utils.getSeparator)(currencyCurrent);
    var currency = (0, _utils.getCurrency)(currencyCurrent);
    var accessoriesPrice = 0;
    var discountDelivery = 0;
    var productPrice = parseFloat($('*[data-attr="summary-product-amount"]').attr('data-value'));
    var deliveryPrice = parseFloat($('*[data-attr="summary-delivery-amount"]').attr('data-value'));
    var discountPrice = parseFloat($('*[data-attr="summary-discount-amount"]').attr('data-value'));
    var orderAmount = parseFloat($summaryOrderAmount.attr('data-value'));

    productPrice = isNaN(productPrice) ? 0 : productPrice;
    deliveryPrice = isNaN(deliveryPrice) ? 0 : deliveryPrice;
    discountPrice = isNaN(discountPrice) ? 0 : discountPrice;

    $inputsAccessory.each(function () {
        if ($(this).is(':checked')) {
            accessoriesPrice = accessoriesPrice + parseFloat($(this).attr('data-acc-price'));
        }
    });

    var taxPrice = calculOALRTax(productPrice, accessoriesPrice, deliveryPrice);
    taxPrice = isNaN(taxPrice) ? 0 : taxPrice;

    orderAmount = productPrice + deliveryPrice + accessoriesPrice + taxPrice - discountPrice - discountDelivery;

    var elOrderAmount = document.querySelector('*[data-attr="summary-order-amount"]');
    var elAccessoriesAmount = document.querySelector('*[data-attr="summary-accessories-amount"]');
    var elTaxAmount = document.querySelector('*[data-attr="summary-tax-amount"]');

    updateHtmlPriceOALR(elTaxAmount, taxPrice, currencyCurrent);
    updateHtmlPriceOALR(elAccessoriesAmount, accessoriesPrice, currencyCurrent);
    updateHtmlPriceOALR(elOrderAmount, orderAmount, currencyCurrent);

    accessoriesPrice > 0 ? $summaryAccessoriesAmount.parent().removeClass('hide').show() : $summaryAccessoriesAmount.parent().hide();
}

function calculOALRTax(productPrice, accessoriesPrice, deliveryPrice) {
    return parseFloat(((productPrice + accessoriesPrice + deliveryPrice) * window.AQUA.TAX_RATE).toFixed(2));
}

function toolsBoxCall(currency) {
    var $deliveryPriceID = $('#delivery-price');
    var $toolboxClass = $('.toolbox-action.free-delivery');
    var $freeDelivery = $toolboxClass.find('i.js-state-action').hasClass('glyphicon-ok');
    var $saveDeliveryPrice = parseFloat($toolboxClass.find('.toolbox-save-delivery-price').val());
    var $saveDeliveryPriceColor = '';
    var $isMinimified = false;
    var fullSize = 0;
    var url = '';

    $toolboxClass.on('click', function () {
        $(this).find('i.js-state-action').toggleClass('glyphicon-remove').toggleClass('glyphicon-ok');
        $freeDelivery = !$freeDelivery;

        if ($freeDelivery) {
            $saveDeliveryPrice = $deliveryPriceID.attr('data-delivery-price');
            $saveDeliveryPriceColor = $deliveryPriceID.css('color');
            $deliveryPriceID.attr('data-delivery-price', '0.00');
            $deliveryPriceID.css('color', 'red').html('0.00 €');
            priceCalcul(currency);
        } else {
            $deliveryPriceID.attr('data-delivery-price', $saveDeliveryPrice);
            $deliveryPriceID.css('color', $saveDeliveryPriceColor).html($saveDeliveryPrice + ' €');
            priceCalcul(currency);
        }

        url = $(this).find('input.toolbox-action-path').val();

        $.post(url);
    });

    var toolboxTitle = '.js-toolbox-title';
    var toolboxMiniHide = '.js-toolbox-mini-hide';
    var toolboxMiniShow = '.js-toolbox-mini-show';

    $(".call-toolbox .js-toolbox-resize").on('click', function () {

        $(this).find('i').toggleClass('glyphicon-minus').toggleClass('glyphicon-plus');
        if (!$isMinimified && fullSize === 0) fullSize = $(this).parent().css('width');
        $isMinimified = !$isMinimified;

        if ($isMinimified) {
            $(toolboxTitle).hide();
            $(toolboxMiniHide).hide();
            $(toolboxMiniShow).show();
            $(this).parent().css('width', '100px');
        } else {
            $(toolboxTitle).show();
            $(toolboxMiniHide).show();
            $(toolboxMiniShow).hide();
            $(this).parent().css('width', fullSize);
        }
    });

    $('[data-toggle="tooltip"]').tooltip();

    $(".js-summary-hide").on('click', function () {
        $('.form-accessories').toggle();
        $(this).find('i').toggleClass('glyphicon-triangle-right').toggleClass('glyphicon-triangle-bottom');
    });

    $(".js-composition-hide").on('click', function () {
        $('.diy-product-list-summary').toggle();
        $(this).find('i').toggleClass('glyphicon-triangle-right').toggleClass('glyphicon-triangle-bottom');
    });
}

function pageOrder(formProductPrices, inputAccessory, currency, productQuantity) {

    // Select
    $(formProductPrices).on('change', function () {
        priceCalcul(currency);
    });

    if (productQuantity) {
        $(productQuantity).on('change', function () {
            priceCalcul(currency);
        });
    }

    // Input accessory
    $(inputAccessory).on('click', function () {
        priceCalcul(currency);
    });

    // Input service
    document.querySelectorAll('.js-service').forEach(function (service) {
        service.addEventListener('click', function () {
            priceCalcul(currency);
        });
    });
    checkAndDisplayServiceTotalLine();

    // Input stickers
    document.querySelectorAll('.js-custom-sticker').forEach(function (sticker) {
        sticker.addEventListener('click', function () {
            priceCalcul(currency);
        });
    });

    // Florist order checkout missing delivery explanation
    var floristMissingDeliveryLink = document.querySelector('.js-form-group-order-recipient-florist-city-missing-link');
    var floristMissingDeliveryBlock = document.querySelector('.js-form-group-order-recipient-florist-city-missing');
    var floristDeliveryExplanationBlock = document.querySelector('.js-form-group-order-recipient-florist-city-explanation');
    if (floristMissingDeliveryLink && floristMissingDeliveryBlock && floristDeliveryExplanationBlock) {
        floristMissingDeliveryLink.addEventListener('click', function () {
            floristMissingDeliveryBlock.style.display = 'none';
            floristDeliveryExplanationBlock.style.display = 'block';
        });
    }

    // Message field suggestion with loco keys
    var messageLocoField = document.querySelector('.js-message');
    var messageLocoSuggestionField = document.querySelector('.js-form-suggestion-loco-message');

    if (messageLocoField && messageLocoSuggestionField) {
        messageLocoSuggestionField.addEventListener("change", function () {
            messageLocoField.value = this.value;
        });
    }

    // Default Bootstrap radio button style
    checkAndChangeClassForDeliveryTypeFields();

    // Check accessories previously selected
    checkAndDisplayAccessoryLines();

    // Funeral message checkbox
    var funeralMessageField = document.querySelector('.js-funeral-message-field');
    var funeralMessageCheckbox = document.querySelector('.js-funeral-message-checkbox');
    if (funeralMessageField && funeralMessageCheckbox) {
        funeralMessageCheckbox.addEventListener('change', function () {
            if (!funeralMessageCheckbox.checked) {
                funeralMessageField.value = '';
            }
        });
        funeralMessageField.addEventListener('change', function () {
            if (!funeralMessageCheckbox.checked) {
                funeralMessageCheckbox.checked = true;
            }
        });
    }

    // Clear anonymous field
    var messageSuggestionField = document.querySelector('.js-form-suggestion-message');
    var messageField = document.querySelector('.js-form-message');
    var signatureField = document.querySelector('.js-form-signature');
    var anonymousField = document.querySelector('.js-form-anonymous input');

    if (messageSuggestionField && anonymousField && anonymousField.checked) {
        messageSuggestionField.addEventListener('change', function () {
            anonymousField.checked = false;
        });
    }
    if (messageField && anonymousField && anonymousField.checked) {
        messageField.addEventListener('keydown', function () {
            anonymousField.checked = false;
        });
    }
    if (signatureField && anonymousField && anonymousField.checked) {
        signatureField.addEventListener('keydown', function () {
            anonymousField.checked = false;
        });
    }
    if (messageSuggestionField && messageField && signatureField && anonymousField) {
        anonymousField.addEventListener('change', function () {
            if (anonymousField.checked) {
                messageSuggestionField.value = '';
                messageField.value = '';
                signatureField.value = '';
            }
        });
    }

    // AJAX address book address selection
    var selectAddressField = document.querySelector('.js-order-select-address-field');
    if (selectAddressField) {
        var savedAddresses = selectAddressField.querySelectorAll('.js-dropdown-value');
        savedAddresses.forEach(function (savedAddress) {
            savedAddress.addEventListener('click', function () {
                if (savedAddress.dataset.value) {
                    fetch('/select-address/' + savedAddress.dataset.value).then(function (response) {
                        if (response) {
                            response.json().then(function (result) {
                                if (result && result.address) {
                                    prefillAddressFields(result.address);
                                }
                            });
                        }
                    });
                }
            });
        });
    }

    // AJAX planning dropdown select
    var planningDay = document.querySelector('.js-form-planning-day');
    if (planningDay) {
        planningDay.addEventListener('change', function () {
            var form = planningDay.closest('form');
            var formData = new FormData();
            formData.append(planningDay.getAttribute('name'), planningDay.value);
            fetch(form.action, {
                method: form.getAttribute('method'),
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function (response) {
                return response.text();
            }).then(function (htmlResponse) {
                var htmlDOM = new DOMParser().parseFromString(htmlResponse.toString(), 'text/html');
                checkAndReplaceQuerySelector('.js-form-planning-time-slot', htmlDOM);
            });
        });
    }

    window.addEventListener("load", function () {
        // Add a keyup event listener to zip code input element
        var nameZipCodeInput = document.querySelector('.js-form-autocomplete-recipient-zip-code');
        if (nameZipCodeInput) {
            nameZipCodeInput.addEventListener("keyup", function (event) {
                autocompleteCity(event, document.querySelector('.js-form-autocomplete-results-zip-code'), 'autocomplete-results-zip-code-item', document.querySelector('.js-form-autocomplete-recipient-city'), document.querySelector('.js-form-autocomplete-recipient-zip-code'), 'data-city', 'data-zip-code', false);
            });
        }

        // Add a keyup event listener to city input element
        var nameCityInput = document.querySelector('.js-form-autocomplete-recipient-city');
        if (nameCityInput) {
            nameCityInput.addEventListener("keyup", function (event) {
                autocompleteCity(event, document.querySelector('.js-form-autocomplete-results-city'), 'autocomplete-results-city-item', document.querySelector('.js-form-autocomplete-recipient-zip-code'), document.querySelector('.js-form-autocomplete-recipient-city'), 'data-zip-code', 'data-city', true);
            });
        }

        // create one global XHR object
        // so we can abort old requests when a new one is make
        window.hinterXHR = new XMLHttpRequest();
    });

    var resultsZipCode = document.querySelector('.js-form-autocomplete-results-zip-code');
    var resultsCity = document.querySelector('.js-form-autocomplete-results-city');
    autocompleteMouseLeave(resultsZipCode);
    autocompleteMouseLeave(resultsCity);

    var deliveryTypes = document.querySelectorAll('.js-form-delivery-type');
    var deliveryToGraveCheckbox = document.querySelector('.js-delivery-to-grave-checkbox');
    var planningTimeSlotField = document.querySelector('.js-form-planning-time-slot');
    var recipientNameField = document.querySelector('.js-form-recipient-name');

    if (deliveryToGraveCheckbox) {
        deliveryTypes.forEach(function (deliveryType) {
            var deliveryTypeRadio = deliveryType.querySelector('.js-form-delivery-type-radio');
            if (AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && deliveryTypeRadio.checked) {
                if (!deliveryToGraveCheckbox.checked) {
                    deliveryToGraveCheckbox.checked = true;
                    checkAndDisplayAccessoryLines();
                }
                changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
            }
            if (planningTimeSlotField && !planningTimeSlotField.value && deliveryTypeRadio.checked) {
                ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);
            }
            if (deliveryTypeRadio.checked) {
                // change funeral labels for chosen delivery type
                changeFuneralLabel(deliveryTypeRadio.value, 'hour');
                changeFuneralLabel(deliveryTypeRadio.value, 'defunct');
                changeFuneralLabel(deliveryTypeRadio.value, 'address');
                changeFuneralLabel(deliveryTypeRadio.value, 'phone');
                changeFuneralLabel(deliveryTypeRadio.value, 'planning-day-label');
            }

            // check is delivery to grave checked on product page (AQCOM)
            if (deliveryToGraveCheckbox.checked && AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && !deliveryTypeRadio.checked && !planningTimeSlotField && recipientNameField && !recipientNameField.value) {
                changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
                deliveryTypeRadio.checked = true;
                checkAndChangeClassForDeliveryTypeFields();

                //re-build form with ajax after delivery type change
                ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);
            }
        });

        deliveryToGraveCheckbox.addEventListener('click', function () {
            changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
        });
    }

    // AJAX planning delivery type select
    if (deliveryTypes) {
        deliveryTypes.forEach(function (deliveryType) {
            deliveryType.addEventListener('click', function () {
                var deliveryTypeRadio = deliveryType.querySelector('.js-form-delivery-type-radio');

                //disable/enable accessory checkboxes
                if (deliveryTypeRadio && deliveryToGraveCheckbox) {
                    deliveryToGraveCheckbox.checked = !!(AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && deliveryToGraveCheckbox);
                    if (AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value && deliveryToGraveCheckbox) {
                        changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, true);
                    } else {
                        changeCheckboxReadOnlyAttribute(deliveryToGraveCheckbox, false);
                    }
                }
                checkAndDisplayAccessoryLines();

                // reinitialize date field
                var planningDayLabel = document.querySelector('.js-form-planning-day');
                if (planningDayLabel) {
                    planningDayLabel.value = '';
                }

                // re-build form with ajax after delivery type change
                ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);

                // update prices
                priceCalcul(currency);
            });

            var deliveryTypeRadio = deliveryType.querySelector('.js-form-delivery-type-radio');
            if (deliveryToGraveCheckbox && AQUA.FUNERAL_DELIVERY_TYPE_CEMETERY === deliveryTypeRadio.value) {
                deliveryToGraveCheckbox.addEventListener('click', function () {
                    if (deliveryToGraveCheckbox.checked) {
                        deliveryTypeRadio.checked = true;

                        //re-build form with ajax after delivery type change
                        ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio);

                        // Update Bootstrap radio button style
                        checkAndChangeClassForDeliveryTypeFields();
                    }
                });
            }
        });
    }
}

function zoomAccessoryOrderPage(eventZoom) {
    $(eventZoom).on('show.bs.modal', function (e) {
        var acc = e.relatedTarget;
        var img = $(acc).attr('data-zoom');
        var id = $(acc).attr('data-id');
        // let input= $(acc).parent().parent().prev().find("input[type='checkbox']");
        var input = $("#" + id);

        var txtButton = '';
        var contentHtml = '';

        if ($(input).is(':disabled')) {
            $(eventZoom + ' a').hide();
        } else {
            $(eventZoom + ' a').show();

            $(input).is(':checked') ? txtButton = window.AQUA.PRODUCT.TRANSLATIONS.REMOVE_ACCESSORIES : txtButton = window.AQUA.PRODUCT.TRANSLATIONS.ADD_ACCESSORIES;

            $(eventZoom + ' a').html(txtButton);
        }

        contentHtml += '<img src="' + img + '" width="550" height="550">\n                        <input type="hidden" value="' + $(input).val() + '"/>';

        $(eventZoom + ' .accessory').html(contentHtml);
    });

    $(eventZoom + ' a').on('click', function () {
        var id = $(this).parent().find('input[type="hidden"]').val();
        var input = "input[value='" + id + "'";

        if (id !== undefined && !$(input).is(':disabled')) {
            $(input).trigger('click');
        }

        $(eventZoom).modal('hide');
    });

    $(eventZoom).on('hidden.bs.modal', function () {
        $(eventZoom + ' .accessory').html('');
    });
}

function paymentPage() {

    var $modalValidateVoucherID = $('#modal-validate-voucher');
    var $paymentTypeCardCLass = $('.payment-type-card');
    var $validVoucherPayment = $('#valid-voucher-payment');

    if ($modalValidateVoucherID.length > 0) {
        $modalValidateVoucherID.modal();
    }

    $validVoucherPayment.on('click', function () {
        $modalValidateVoucherID.modal('hide');
    });

    // Payment color
    $paymentTypeCardCLass.on('click', function () {
        $paymentTypeCardCLass.each(function () {
            if ($(this).hasClass('active')) $(this).removeClass('active');
        });
        $(this).toggleClass('active');
    });
}

function loadTemplate(stringJson) {
    var $content = $('#form_order_checkout_message');
    var message = '';

    $.getJSON(stringJson, {
        format: "json"
    }).done(function (data) {
        message = data;
        chargeMessage(message);
    });

    $('#suggestion_mess').on('change', function () {
        var id_mess = $(this).val();
        $content.html(message.message[id_mess]);
        $content.val(message.message[id_mess]);
    });
}

function chargeMessage(data) {
    var category = data.type;
    var selectBox = $('#suggestion_mess');

    $.each(category, function (i) {
        if ((undefined === window.AQUA.FUNERAL_PRODUCT || '' === window.AQUA.FUNERAL_PRODUCT) && 'DEUIL' !== category[i].titre) {
            selectBox.append('<option disabled="disabled" value="-1">-----------------------</option>');
            selectBox.append('<optgroup label="' + category[i].titre + '">');
        }
        if ((undefined === window.AQUA.FUNERAL_PRODUCT || '' === window.AQUA.FUNERAL_PRODUCT) && 'DEUIL' !== category[i].titre || '' !== window.AQUA.FUNERAL_PRODUCT && 'DEUIL' === category[i].titre) {
            var list = category[i].liste;
            $.each(list, function (x) {
                selectBox.append('<option value="' + list[x].i + '">' + list[x].t + '</option>');
            });
            selectBox.append('</optgroup>');
        }
    });
}

function uploadInformationAccordion() {
    var uploadTypes = [{ origin: '.upload-photo__carret', target: '.upload-photo__info' }, { origin: '.upload-video__carret', target: '.upload-video__info' }, { origin: '.accessories-list__carret', target: '.accessories-list__info' }, { origin: '.accessories-list-mobile__carret', target: '.accessories-list-mobile__info' }, { origin: '.total-list__carret', target: '.total-list__info' }];

    uploadTypes.forEach(function (uploadType) {
        return $(uploadType.origin).on('click', function () {
            if ($(this).hasClass('active')) {
                $(uploadType.origin).removeClass('active');
                $(uploadType.target).removeClass('active');
            } else {
                (0, _utils.ufToggleClassElement)('active', [$(this), $(this).attr('data-target')]);
            }
        });
    });
}

function dynamicPriceProductCard() {
    var isProductDIYDynamicPrice = document.querySelector('.js-diy-dynamic-price');
    if (!isProductDIYDynamicPrice) {
        return;
    }

    var products = document.querySelectorAll('.js-component-price');
    var totalProductPrice = document.querySelector('.js-total-diy');
    var productRemoved = document.querySelectorAll('.js-product-remove');

    window.addEventListener('DOMContentLoaded', function () {
        calculProductsPrice(products, totalProductPrice);
    });

    products.forEach(function (productCard) {
        productCard.addEventListener('change', function (event) {
            priceCalcul(window.AQUA.INIT_CURRENCY);
        });
    });

    productRemoved.forEach(function (product) {
        product.addEventListener('click', function (event) {
            var selectedProduct = product.dataset.product;
            var select = document.querySelector(".js-select-" + selectedProduct);
            product.parentElement.dataset.totalPrice = 0;
            product.parentElement.classList.add('hidden');
            select.selectedIndex = 0;
            calculProductsPrice(products, totalProductPrice);
        });
    });
}

function selectsStatutNotification(jsclass) {

    if (jsclass) {
        jsclass.addEventListener('change', function () {
            if (this.value == "") {
                jsclass.classList.remove("select--valid");
                jsclass.classList.add("select--invalid");
            } else {
                jsclass.classList.remove("select--invalid");
                jsclass.classList.add("select--valid");
            }
        });
    }
}

function verifSelectInputStatutNotification() {

    var btnSummit = document.querySelectorAll('.js-button-green');
    btnSummit.forEach(function (elt) {

        elt.addEventListener('click', function (event) {

            var selectsRequired = document.querySelectorAll('select[required]');
            var inputsRequired = document.querySelectorAll('input[required]');

            selectsRequired.forEach(function (selectRequired) {
                selectRequired.value == "" ? selectRequired.classList.add("select--invalid") : null;
            });

            inputsRequired.forEach(function (inputRequired) {
                if (inputRequired.value.length == 0) {
                    inputRequired.classList.add("input--invalid");
                }
            });
        });
    });
}

function inputsStatutNotification() {
    var inputs = document.querySelectorAll("[type='text'][required], [type='tel'], [type='email'] ");
    inputs.forEach(function (elt) {

        elt.addEventListener('input', function (event) {
            event.currentTarget.classList.remove('input--valid', 'input--invalid');
            event.currentTarget.value.length > 0 ? event.currentTarget.classList.add("input--valid") : event.currentTarget.classList.add("input--invalid");
        });

        elt.addEventListener('focusout', function (event) {
            var isValidInput = void 0;
            switch (event.currentTarget.type) {
                case 'text':
                    isValidInput = event.currentTarget.value.length !== 0;
                    break;
                case 'tel':
                    if (window.intlTelInputGlobals) {
                        var iti = window.intlTelInputGlobals.getInstance(event.currentTarget);
                        isValidInput = iti.isValidNumber();
                    }
                    break;
                case 'email':
                    var mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    isValidInput = mailRegex.test(event.currentTarget.value.toLowerCase());
                    break;
                default:
            }

            event.currentTarget.classList.remove('input--valid', 'input--invalid');
            isValidInput ? event.currentTarget.classList.add("input--valid") : event.currentTarget.classList.add("input--invalid");
        });
    });
}

function ajaxDeliveryTypesBuildForm(deliveryType, deliveryTypeRadio) {
    var form = deliveryType.closest('form');
    var formData = new FormData();
    formData.append(deliveryTypeRadio.getAttribute('name'), deliveryTypeRadio.value);
    fetch(form.action, {
        method: form.getAttribute('method'),
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function (response) {
        return response.text();
    }).then(function (htmlResponse) {
        var htmlDOM = new DOMParser().parseFromString(htmlResponse.toString(), 'text/html');
        checkAndReplaceQuerySelector('.js-form-group-planning-time-slot', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-group-funeral-hour', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-title', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-name', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-first-name', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-address', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-additional-address', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-door-code', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-second-door-code', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-stair', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-floor', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-recipient-instruction', htmlDOM);
        checkAndReplaceQuerySelector('.js-form-save-address', htmlDOM);

        if (document.querySelector('.js-form-group-recipient-additional-address') && document.querySelector('.js-form-group-recipient-address')) {
            if (AQUA.FUNERAL_DELIVERY_TYPE_RESIDENCE === deliveryTypeRadio.value) {
                document.querySelector('.js-form-group-recipient-address').after(document.querySelector('.js-form-group-recipient-additional-address'));
            } else {
                document.querySelector('.js-form-group-recipient-additional-address').after(document.querySelector('.js-form-group-recipient-address'));
            }
        }

        // change funeral labels for chosen delivery type
        changeFuneralLabel(deliveryTypeRadio.value, 'hour');
        changeFuneralLabel(deliveryTypeRadio.value, 'defunct');
        changeFuneralLabel(deliveryTypeRadio.value, 'address');
        changeFuneralLabel(deliveryTypeRadio.value, 'phone');
        changeFuneralLabel(deliveryTypeRadio.value, 'planning-day-label');
    });
}

// Autocomplete for form
function autocompleteCity(event, dataList, autoCompleteResultsItemClass, sourceField, destinationField, sourceQualifierName, destinationQualifierName, isCitySource) {

    // retrieve the input element
    var input = event.target;

    // minimum number of characters before we start to generate suggestions
    var minCharacters = 4;

    if (input.value.length >= minCharacters) {

        // abort any pending requests
        window.hinterXHR.abort();

        window.hinterXHR.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {

                // We're expecting a json response so we convert it to an object
                var response = JSON.parse(this.responseText);
                if (dataList) {
                    // clear any previously loaded options in the datalist
                    dataList.innerHTML = "";
                    if (response && response.length > 0) {
                        response.forEach(function (item) {
                            dataList.innerHTML += '<li>' + '<a class="' + autoCompleteResultsItemClass + '" data-city="' + item.name + '" data-zip-code="' + item.zip_code + '">' + (isCitySource ? item.name + ' (' + item.zip_code + ')' : item.zip_code + ' - ' + item.name) + '</a></li>';
                        });
                    }

                    var autocompleteResultsItems = document.querySelectorAll('.' + autoCompleteResultsItemClass);
                    if (autocompleteResultsItems) {
                        autocompleteResultsItems.forEach(function (autocompleteResultsItem) {
                            autocompleteResultsItem.addEventListener('click', function (event) {
                                sourceField.value = autocompleteResultsItem.getAttribute(sourceQualifierName);
                                destinationField.value = autocompleteResultsItem.getAttribute(destinationQualifierName);
                                dataList.style.display = 'none';
                            });
                        });
                    }
                    dataList.style.display = 'block';
                }
            }
        };

        window.hinterXHR.open("GET", "/autocomplete-city/" + input.value, true);
        window.hinterXHR.send();
    }
}

function autocompleteMouseLeave(fieldResults) {
    if (fieldResults) {
        fieldResults.addEventListener("mouseleave", function (event) {
            fieldResults.style.display = 'none';
        }, false);
    }
}

function calculProductsPrice(products, totalProductPrice) {
    var productPrice = 0;

    products.forEach(function (product) {
        productPrice += parseFloat(product.dataset.totalPrice);
    });

    if (totalProductPrice) {
        totalProductPrice.dataset.totalProductPrice = productPrice;
        totalProductPrice.innerHTML = (0, _utils.getFormatedPrice)(window.AQUA.LOCALE, (0, _utils.getCurrency)(window.AQUA.INIT_CURRENCY), parseFloat(productPrice).toFixed(2).replace(".", ","));
        priceCalcul(window.AQUA.INIT_CURRENCY);
    }
}

function changeFuneralLabel(deliveryTypeRadioValue, field) {
    var currentFuneralText = document.querySelector('.js-funeral-' + deliveryTypeRadioValue + '-' + field + '-text');
    var funeralTexts = document.querySelectorAll('.js-funeral-' + field + '-text');
    if (funeralTexts) {
        funeralTexts.forEach(function (funeralText) {
            funeralText.classList.add('hidden');
        });
    }
    if (currentFuneralText) {
        currentFuneralText.classList.remove('hidden');
    }
}

function checkAndChangeClassForDeliveryTypeFields() {
    var deliveryTypeFields = document.querySelectorAll('.js-form-delivery-type');
    deliveryTypeFields.forEach(function (deliveryTypeField) {
        deliveryTypeField.classList.remove('active');
        if (deliveryTypeField) {
            for (var i = 0; i < deliveryTypeField.childNodes.length; i++) {
                if (deliveryTypeField.childNodes[i].checked) {
                    deliveryTypeField.classList.add('active');
                }
            }
        }
    });
}

function checkAndDisplayAccessoryLines() {
    var accessoryLines = document.querySelectorAll(".js-accessory-line");
    accessoryLines.forEach(function (accessoryLine) {
        var accessorySelector = document.querySelector('input[id="accessory-' + accessoryLine.getAttribute('data-accessory-id') + '"]');
        if (undefined !== accessorySelector && accessorySelector.checked) {
            accessoryLine.classList.remove('hidden');
        } else {
            accessoryLine.classList.add('hidden');
        }
    });
}

function checkAndReplaceQuerySelector(selector, htmlDOM) {
    if (document.querySelector(selector) && htmlDOM.querySelector(selector)) {
        // Don't add form error class for ajax field replacement
        var DOMInputElements = htmlDOM.querySelectorAll('input');
        DOMInputElements.forEach(function (DOMInputElement) {
            if (undefined !== DOMInputElement.classList) {
                DOMInputElement.classList.remove('has-error');
            }
        });
        // Replace field
        document.querySelector(selector).replaceWith(htmlDOM.querySelector(selector));
    }
}

function changeCheckboxReadOnlyAttribute(checkbox, isActivated) {
    checkbox.readOnly = isActivated;
    checkbox.labels.forEach(function (label) {
        if (isActivated) {
            label.setAttribute('readOnly', 'readonly');
        } else {
            label.removeAttribute('readOnly');
        }
    });
}

// show hidden schedules block (florist delivery choice page)
function showFloristSchedules() {

    var schedulesBlock = document.querySelector(".js-florist-information-schedules");
    var schedulesBlockHidden = document.querySelector(".js-florist-information-schedules-hidden");

    if (schedulesBlock) {
        schedulesBlock.addEventListener('click', function (event) {
            schedulesBlock.remove();
            schedulesBlockHidden.style.display = "inline";
        });
    }
}

//Florist delivery choice events
function updateFloristDeliveryLocationValue() {
    var floristDeliveryChoiceFormChoices = document.querySelectorAll('.js-florist-delivery-choice-form-choice');
    var floristDeliveryChoiceFormChoiceFlorist = document.querySelector('.js-florist-delivery-choice-form-choice-florist');
    var floristDeliveryChoiceFormDeliveryLocation = document.querySelector('.js-florist-delivery-choice-form-delivery-location');

    if (floristDeliveryChoiceFormChoices && floristDeliveryChoiceFormChoiceFlorist && floristDeliveryChoiceFormDeliveryLocation) {
        floristDeliveryChoiceFormChoices.forEach(function (floristDeliveryChoiceFormChoice) {
            floristDeliveryChoiceFormChoice.addEventListener("click", function () {
                floristDeliveryChoiceFormDeliveryLocation.value = '';
            });
        });
        floristDeliveryChoiceFormDeliveryLocation.addEventListener("change", function () {
            floristDeliveryChoiceFormChoiceFlorist.checked = true;
        });
    }
}

// prefill address fields after saved address selection
function prefillAddressFields(address) {
    var titleBlock = document.querySelector('.js-form-recipient-title');
    if (titleBlock && address.civility && address.civility.id) {
        var titleInputFields = titleBlock.querySelectorAll('[type="radio"]');
        titleInputFields.forEach(function (titleInputField) {
            titleInputField.checked = titleInputField.value === address.civility.id.toString();
        });
    }
    var nameField = document.querySelector('.js-form-recipient-name');
    if (nameField) {
        nameField.value = address.name;
    }
    var firstnameField = document.querySelector('.js-form-recipient-first-name');
    if (firstnameField) {
        firstnameField.value = address.first_name;
    }
    var companyField = document.querySelector('.js-form-recipient-company');
    if (companyField) {
        companyField.value = address.society;
    }
    var addressField = document.querySelector('.js-form-recipient-address');
    if (addressField) {
        addressField.value = address.address_line1;
    }
    var additionalAddressField = document.querySelector('.js-form-recipient-additional-address');
    if (additionalAddressField) {
        additionalAddressField.value = address.address_line2;
    }
    var zipCodeField = document.querySelector('.js-form-autocomplete-recipient-zip-code');
    if (zipCodeField) {
        zipCodeField.value = address.zip_code;
    }
    var cityField = document.querySelector('.js-form-autocomplete-recipient-city');
    if (cityField) {
        cityField.value = address.city;
    }
    var doorCodeField = document.querySelector('.js-form-recipient-door-code-input');
    if (doorCodeField) {
        doorCodeField.value = address.door_code1;
    }
    var secondDoorCodeField = document.querySelector('.js-form-recipient-second-door-code-input');
    if (secondDoorCodeField) {
        secondDoorCodeField.value = address.door_code2;
    }
    var stairField = document.querySelector('.js-form-recipient-stair-input');
    if (stairField) {
        stairField.value = address.staircase;
    }
    var floorField = document.querySelector('.js-form-recipient-floor-input');
    if (floorField) {
        floorField.value = address.floor;
    }
    var phoneField = document.querySelector('.js-form-recipient-phone');
    if (phoneField) {
        phoneField.value = address.phone;
    }
}

function checkAndDisplayServiceTotalLine() {
    if (document.querySelector('[data-switch="services-price"]')) {
        var servicesPrice = 0;

        document.querySelectorAll('.js-service').forEach(function (service) {
            if (service.checked && service.dataset.accPrice > 0) {
                servicesPrice = servicesPrice + parseFloat(service.dataset.accPrice);
            }
        });

        var parentNode = (0, _utils.getParentNode)(document.querySelector('[data-switch="services-price"]'), 'table-summary-line');
        if (parentNode !== false) {
            if (servicesPrice === 0) {
                parentNode.style.display = "none";
            } else {
                parentNode.style.display = "table";
            }
        }
    }
}

function updateProductQuantityOnOrderPage() {
    function updateQuantity(element, increment) {
        var productListElement = element.closest('.js-order-checkout-product-list-item');
        var inputQuantity = productListElement.querySelector('.js-product-quantity');
        var textQuantity = productListElement.querySelector('.js-order-product-quantity');
        var addProductButton = productListElement.querySelector('.js-add-product');
        var removeProductButton = productListElement.querySelector('.js-remove-product');

        var currentQuantity = parseInt(inputQuantity.value, 10);
        var max = parseInt(inputQuantity.getAttribute('max'), 10);
        var min = parseInt(inputQuantity.getAttribute('min'), 10);

        currentQuantity += increment ? 1 : -1;

        addProductButton.classList.remove('quantity-button--disabled');
        removeProductButton.classList.remove('quantity-button--disabled');

        if (currentQuantity >= max) {
            currentQuantity = max;
            addProductButton.classList.add('quantity-button--disabled');
        } else if (currentQuantity <= min) {
            removeProductButton.classList.add('quantity-button--disabled');
            currentQuantity = min;
        }

        inputQuantity.value = currentQuantity;
        textQuantity.innerText = currentQuantity.toString();
        textQuantity.dataset.productQuantity = currentQuantity;

        inputQuantity.dispatchEvent(new Event('change'));
    }
    document.querySelectorAll('.js-add-product').forEach(function (button) {
        button.addEventListener('click', function () {
            updateQuantity(this, true);
        });
    });

    document.querySelectorAll('.js-remove-product').forEach(function (button) {
        button.addEventListener('click', function () {
            updateQuantity(this, false);
        });
    });
}

function updateAccessoryQuantityOnOrderPage() {
    function updateQuantity(element, increment) {
        var accessoryListElement = element.closest('.js-order-checkout-accessory-list-item');
        var inputQuantity = accessoryListElement.querySelector('.js-accessory-quantity');
        var textQuantity = accessoryListElement.querySelector('.js-order-accessory-quantity');
        var addAccessoryButton = accessoryListElement.querySelector('.js-add-accessory');
        var accessorySingleAddButton = accessoryListElement.querySelector('.js-accessory-single-add-button');
        var accessoryButtons = accessoryListElement.querySelector('.js-accessory-buttons');

        var currentQuantity = parseInt(inputQuantity.value, 10);
        var max = parseInt(inputQuantity.getAttribute('max'), 10);
        var min = parseInt(inputQuantity.getAttribute('min'), 10);

        currentQuantity += increment ? 1 : -1;
        accessoryListElement.classList.add('selected');

        if (!increment) {
            addAccessoryButton.classList.remove('quantity-button--disabled');
        }

        if (currentQuantity >= max) {
            currentQuantity = max;
            addAccessoryButton.classList.add('quantity-button--disabled');
        } else if (currentQuantity <= min) {
            currentQuantity = min;
            accessoryListElement.classList.remove('selected');
            accessoryButtons.classList.add('hidden');
            accessorySingleAddButton.classList.remove('hidden');
        } else {
            accessoryButtons.classList.remove('hidden');
            accessorySingleAddButton.classList.add('hidden');
        }

        inputQuantity.value = currentQuantity;
        inputQuantity.dispatchEvent(new Event('click'));
        textQuantity.textContent = currentQuantity.toString();
    }

    document.querySelectorAll('.js-add-accessory').forEach(function (button) {
        button.addEventListener('click', function () {
            updateQuantity(this, true);
        });
    });

    document.querySelectorAll('.js-remove-accessory').forEach(function (button) {
        button.addEventListener('click', function () {
            updateQuantity(this, false);
        });
    });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"./utils":3,"jquery":6}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toTop = toTop;
exports.dropdownMenu = dropdownMenu;
exports.headerFixed = headerFixed;
exports.initBanner = initBanner;
exports.getFormatedPrice = getFormatedPrice;
exports.getCurrency = getCurrency;
exports.getSeparator = getSeparator;
exports.hasScrollToTop = hasScrollToTop;
exports.popitup = popitup;
exports.backToTop = backToTop;
exports.changePlaceholderAndLabelForTheLogin = changePlaceholderAndLabelForTheLogin;
exports.toggleLoginPlaceholderAndLabel = toggleLoginPlaceholderAndLabel;
exports.closeModal = closeModal;
exports.zoomModalPhoto = zoomModalPhoto;
exports.zoomModalMultiPhotos = zoomModalMultiPhotos;
exports.loadProductSameday = loadProductSameday;
exports.ufToggleClassElement = ufToggleClassElement;
exports.thumbnailProduct = thumbnailProduct;
exports.selectSizeCustomByRadio = selectSizeCustomByRadio;
exports.clickOnCatalogMobileProduct = clickOnCatalogMobileProduct;
exports.lazyLoadingImg = lazyLoadingImg;
exports.isIOS = isIOS;
exports.clickOnCheckboxInputReadOnly = clickOnCheckboxInputReadOnly;
exports.getParentNode = getParentNode;

var _cookieconsent = require('cookieconsent');

var _cookieconsent2 = _interopRequireDefault(_cookieconsent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

if (window.jQuery === undefined) {
    window.jQuery = window.$ = require('jquery');
}
function toTop(element) {
    if ($(element).length) {
        var scrollTrigger = 300,
            // px
        _backToTop = function _backToTop() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
                $(element).addClass('show');
            } else {
                $(element).removeClass('show');
            }
        };

        _backToTop();
        $(window).on('scroll', function () {
            _backToTop();
        });

        $(element).on('click', function () {
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
}

function dropdownMenu() {
    $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().siblings().removeClass('open');
        $(this).parent().toggleClass('open');
    });
    $('.js-dropdown-last-item>a').on('click', function () {
        var $el = $(this);
        if ($el.length && $el.attr('href')) {
            location.href = $el.attr('href');
        }
    });
}

function headerFixed() {
    var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var headerFixed = document.querySelector('.js-header-fixed');
    var body = document.querySelector('.js-body');

    if (enabled && headerFixed) {
        window.addEventListener('scroll', function () {
            var headerHeight = headerFixed.offsetHeight;

            if (window.scrollY > 0) {
                headerFixed.classList.add('header-fixed');
                body.style.paddingTop = headerHeight + 'px';
            } else {
                headerFixed.classList.remove('header-fixed');
                body.style.paddingTop = '';
            }
        });
    }
}

function initBanner() {
    window.cookieconsent.initialise({
        "theme": "aqua",
        "position": "bottom-right",
        "content": {
            "message": window.AQUA.BANNER_MESSAGE,
            "dismiss": window.AQUA.BANNER_DISMISS,
            "link": window.AQUA.BANNER_LINK,
            "href": window.AQUA.BANNER_HREF
        },
        "cookie": {
            "domain": window.AQUA.BANNER_DOMAIN
        }
    });
}

function getFormatedPrice(locale, currency, price) {
    if (locale === 'en') {
        return window.AQUA.PARTNER === '12' ? getFormatedPriceOalr(price, currency) : currency + price;
    } else {
        return price + '\xa0' + currency;
    }
}

function getFormatedPriceOalr(price, currency) {
    var priceSplited = price.replace(',', '.').split('.');
    return '<span class="format-price">' + currency + priceSplited[0] + '</span>';
}

function getCurrency(initCurrency) {
    var currency = '';
    if (initCurrency === 'EUR') {
        currency = '€';
    } else if (initCurrency === 'CHF') {
        currency = 'CHF';
    } else if (initCurrency === 'USD') {
        currency = '$';
    } else if (initCurrency === 'GBP') {
        currency = 'GBP';
    }

    return currency;
}

function getSeparator(initCurrency) {
    var separator = '';
    if (initCurrency === 'EUR') {
        separator = ',';
    } else if (initCurrency === 'CHF') {
        separator = ',';
    } else if (initCurrency === 'USD') {
        separator = '.';
    } else if (initCurrency === 'GBP') {
        separator = '.';
    }

    return separator;
}

function hasScrollToTop() {
    $('.navigation a').on('click', function () {
        var page = $(this).attr('href');
        var speed = 750;
        $('html, body').animate({ scrollTop: $(page).offset().top }, speed);
        return false;
    });
}

function popitup(url) {
    var newWindow = window.open(url, 'name', 'height=600,width=500');
    if (window.focus) {
        newWindow.focus();
    }
    return false;
}

function backToTop(element) {
    if ($(element).length) {
        var scrollTrigger = 300,
            // px
        _backToTop2 = function _backToTop2() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
                $(element).addClass('show');
            } else {
                $(element).removeClass('show');
            }
        };

        _backToTop2();
        $(window).on('scroll', function () {
            _backToTop2();
        });

        $(element).on('click', function () {
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
}

function changePlaceholderAndLabelForTheLogin() {

    var $label = $('.connect-form .username-label-js');
    var $input = $('.connect-form #username');
    var $inputMobile = $('.connect-form #mobile-username');
    var $Registerbtn = $('.js-register-account-btn');
    var $resetPasswordLink = $('.js-reset-password-link');
    var hrefResetPasswordLink = $resetPasswordLink.attr('href');

    $('input:radio[name=_type]').on('change', function () {
        changeLoginLabel(this, $label, $input, $inputMobile);
        changeRegisterButton(this, $Registerbtn);
        changeResetPassword(this, $resetPasswordLink, hrefResetPasswordLink);
    });

    if (location.href.split('?')[1] !== undefined && location.href.split('?')[1] === 'mode=register') {
        $("button[data-target='#modal-create-account']").trigger('click');
    }

    $('input:radio[name=_type][checked]').each(function () {
        changeLoginLabel(this, $label, $input, $inputMobile);
    });
}

function toggleLoginPlaceholderAndLabel(forms) {
    forms.forEach(function (form) {
        var usernameLabel = $(form.querySelector('.username-label-js'));
        var usernameInput = $(form.querySelector('.username-input-js'));

        [].concat(_toConsumableArray(form.querySelectorAll('input[type=radio][name=_type]'))).forEach(function (input) {
            input.addEventListener('change', function (event) {
                changeLoginLabel(input, usernameLabel, usernameInput, usernameInput);
            });

            if (input.checked) {
                changeLoginLabel(input, usernameLabel, usernameInput, usernameInput);
            }
        });
    });
}

function closeModal(element) {
    $(element).on('click', function () {
        ufToggleClassElement('active', [$(this).parent()]);
    });
}

function zoomModalPhoto() {
    var modalPhoto = document.querySelector('.js-modal-photo');
    var modalPhotoZoom = document.querySelector('.js-modal-photo-zoom');
    var modalClosePhoto = document.querySelector('.js-modal-photo-close');

    if (modalPhoto && modalPhotoZoom && modalClosePhoto) {
        modalPhoto.addEventListener('click', function () {
            modalPhotoZoom.style.display = "block";
            modalPhotoZoom.classList.add("in");
        });
        modalClosePhoto.addEventListener("click", function () {
            modalPhotoZoom.style.display = "none";
        });
    }
}

function zoomModalMultiPhotos() {
    var modalPhotos = document.querySelectorAll('.js-modal-multi-photo');
    var modalPhotoZoom = document.querySelector('.js-modal-multi-photo-zoom');
    var modalClosePhoto = document.querySelector('.js-modal-multi-photo-close');
    var modalImg = document.querySelector('.js-modal-multi-photo-zoom .resume-order__img');

    if (modalPhotos) {
        modalPhotos.forEach(function (modalPhoto, iteration) {
            var modalPhotoId = modalPhoto.dataset.photoId;
            modalPhoto.addEventListener('click', function () {
                if (iteration > 0) {
                    modalImg.src = modalImg.src.replace('.jpg', '-' + modalPhotoId + '.jpg');
                }
                modalPhotoZoom.style.display = "block";
                modalPhotoZoom.classList.add("in");
            });
            modalClosePhoto.addEventListener("click", function () {
                if (iteration > 0) {
                    modalImg.src = modalImg.src.replace('-' + modalPhotoId + '.jpg', '.jpg');
                }
                modalPhotoZoom.style.display = "none";
            });
        });
    }
}

function loadProductSameday() {
    var modalSamedayCatalog = '#modal-sameday-catalog';
    var modalSamedayBody = '#modal-sameday-catalog .modal-body';

    $(modalSamedayCatalog).on('show.bs.modal', function () {
        if ($(modalSamedayCatalog + ' section[data-section=catalog]').length == 0) {
            $.ajax({
                url: window.AQUA.URL_LOAD_SAMEDAY
            }).done(function (response) {
                $(modalSamedayBody).html(response);
                $(modalSamedayBody + ' article').on('click', function () {
                    if ($(this).find('a.btn-commander.btn-commander-js').is(':hidden')) {
                        location.href = $(this).find('div.product-button a').attr('href');
                    }
                });
            });
        }
    });
}

function ufToggleClassElement(element, targets) {
    $(targets).each(function (key) {
        $(targets[key]).toggleClass(element);
    });
}

// Protected, don't touch !
function changeLoginLabel(context, $label, $input, $inputMobile) {
    if (context !== undefined) {
        if (context.value == 1) {
            $label.html(window.AQUA.AUTH.TRANSLATIONS.EMAIL_LABEL);
            $input.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.EMAIL_PLACEHOLDER });
            $inputMobile.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.EMAIL_PLACEHOLDER });
        }

        if (context.value == 2) {
            $label.html(window.AQUA.AUTH.TRANSLATIONS.CODE_LABEL);
            $input.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.CODE_PLACEHOLDER });
            $inputMobile.attr({ placeholder: window.AQUA.AUTH.TRANSLATIONS.CODE_PLACEHOLDER });
        }
    }
}

function changeRegisterButton(context, $registerButton) {

    if (context !== undefined) {
        if (context.value == 1) {
            $registerButton.attr({ href: $registerButton.data('private') });
        } else if (context.value == 2) {
            $registerButton.attr({ href: $registerButton.data('business') });
        }
    }
}

function changeResetPassword(context, $resetPasswordLink, hrefResetPasswordLink) {

    if (context !== undefined) {
        if (context.value == 1) {
            $resetPasswordLink.attr({ href: hrefResetPasswordLink + "?b2b=0" });
        } else if (context.value == 2) {
            $resetPasswordLink.attr({ href: hrefResetPasswordLink + "?b2b=1" });
        }
    }
}

function thumbnailProduct() {

    var modalImageProductId = '#modal-img-produit';

    $(document).on('click', '.more', function () {
        ufToggleClassElement('active', [$(this), $(this).prev()]);
    });

    $(document).on('click', '.hide-full-txt', function () {
        ufToggleClassElement('active', [$(this).parent(), $(this).parent().next()]);
    });

    $(document).on('click', ".zoom", function () {
        $(modalImageProductId + ' .modal-body').html('<img src="' + $(this).attr("data-img") + '" />');
        $(modalImageProductId).modal('show');
    });
}

function selectSizeCustomByRadio(element) {
    var radios = document.querySelectorAll(element);
    if (radios.length) {
        radios.forEach(function (radio) {
            radio.addEventListener('click', function (event) {
                var targetRadio = radio.getAttribute("data-target");
                var radioContainer = event.currentTarget.closest('.price-radio');

                if (document.querySelectorAll('input#' + targetRadio).length) {
                    var previousRadioSelected = radioContainer.querySelector(element + '.radio-selected');
                    previousRadioSelected.classList.remove('radio-selected');
                    event.currentTarget.classList.add('radio-selected');

                    radioContainer.querySelectorAll('input[type="radio"]').forEach(function (radioInput) {
                        radioInput.checked = false;
                        if (radioInput.getAttribute('id') === targetRadio) {
                            radioInput.checked = true;
                        }
                    });
                }
            });
        });
    }
}

function clickOnCatalogMobileProduct() {
    $('section[data-section="catalog"] article').on('click', function (e) {
        if ($(this).find('a.btn-commander.btn-commander-js').is(':hidden')) location.href = $(this).find('div.product-button a').attr('href');
    });
}

function lazyLoadingImg(imgElement) {
    var options = {
        root: null,
        rootMargin: '120px 0px',
        threshold: 0
    };

    if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    getPicture(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        [].concat(_toConsumableArray(document.querySelectorAll(imgElement))).forEach(function (img) {
            if (img.nodeName === "IMG" && img !== null) {
                observer.observe(img);
            }
        });
    } else {
        var img = document.querySelectorAll(imgElement);
        for (var i = 0; i < img.length; i++) {
            getPicture(img[i]);
        }
    }
}

function getPicture(element) {
    element.src = element.attributes["data-src"] ? element.attributes["data-src"].value : element.src;
    element.srcset = element.attributes["data-srcset"] ? element.attributes["data-srcset"].value : element.srcset;
    element.removeAttribute("data-src");
    element.removeAttribute("data-srcset");
}

function isIOS() {
    var onlySafari = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var userAgent = navigator.userAgent;
    var Safari = onlySafari === true ? userAgent.match(/Safari/i) !== null : true;
    var AppleDevices = ['iPhone', 'IOS', 'Ipod'];

    return AppleDevices.some(function (device) {
        return userAgent.match(new RegExp(device, 'i')) && Safari;
    });
}

function clickOnCheckboxInputReadOnly(label, inputReadOnly, inputCheckbox) {
    label = document.querySelector(label);
    inputReadOnly = document.querySelector(inputReadOnly);
    inputCheckbox = document.querySelector(inputCheckbox);

    if (label) {
        label.addEventListener('click', function () {
            inputCheckbox.checked === false ? inputReadOnly.readOnly = true : inputReadOnly.readOnly = false;
        });
    }
}

function getParentNode(node, parentSelector) {
    var found = false;

    while (node != document.body) {
        if (!node) break;

        if (node.classList && node.classList.contains(parentSelector)) {
            found = true;
            break;
        }
        node = node.parentNode;
    }

    if (!found) return false;

    return node;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"cookieconsent":5,"jquery":6}],4:[function(require,module,exports){
"use strict";

var _utils = require("./components/utils");

var _order = require("./components/order");

var _collapse = require("./components/collapse");

document.addEventListener('DOMContentLoaded', function () {

    var elementToTop = '.js-back-to-top';
    (0, _utils.backToTop)(elementToTop);

    (0, _utils.headerFixed)(true);

    (0, _order.selectsStatutNotification)(document.querySelector(".js-form-funeral-hour"));
    (0, _order.selectsStatutNotification)(document.querySelector(".js-form-funeral-minute"));
    (0, _order.selectsStatutNotification)(document.querySelector(".js-form-planning-day"));

    (0, _order.inputsStatutNotification)();
    (0, _order.verifSelectInputStatutNotification)();

    (0, _utils.dropdownMenu)();
    (0, _collapse.adjustCollapse)('.description-text');
}, false);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZha2VfOGU2NGQ4MzAuanMiXSwibmFtZXMiOlsiZG9jdW1lbnQiLCJhZGRFdmVudExpc3RlbmVyIiwiZWxlbWVudFRvVG9wIiwicXVlcnlTZWxlY3RvciJdLCJtYXBwaW5ncyI6Ijs7QUFBQTs7QUFDQTs7QUFDQTs7QUFHQUEsU0FBU0MsZ0JBQVQsQ0FBMEIsa0JBQTFCLEVBQThDLFlBQU07O0FBRWhELFFBQU1DLGVBQWUsaUJBQXJCO0FBQ0EsMEJBQVVBLFlBQVY7O0FBRUEsNEJBQVksSUFBWjs7QUFFQSwwQ0FBMEJGLFNBQVNHLGFBQVQsQ0FBdUIsdUJBQXZCLENBQTFCO0FBQ0EsMENBQTBCSCxTQUFTRyxhQUFULENBQXVCLHlCQUF2QixDQUExQjtBQUNBLDBDQUEwQkgsU0FBU0csYUFBVCxDQUF1Qix1QkFBdkIsQ0FBMUI7O0FBRUE7QUFDQTs7QUFFQTtBQUNBLGtDQUFlLG1CQUFmO0FBRUgsQ0FqQkQsRUFpQkcsS0FqQkgiLCJmaWxlIjoiZmFrZV84ZTY0ZDgzMC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7YmFja1RvVG9wLCBkcm9wZG93bk1lbnUsIGhlYWRlckZpeGVkfSBmcm9tIFwiLi9jb21wb25lbnRzL3V0aWxzXCI7XG5pbXBvcnQge2lucHV0c1N0YXR1dE5vdGlmaWNhdGlvbiwgc2VsZWN0c1N0YXR1dE5vdGlmaWNhdGlvbiwgdmVyaWZTZWxlY3RJbnB1dFN0YXR1dE5vdGlmaWNhdGlvbn0gZnJvbSBcIi4vY29tcG9uZW50cy9vcmRlclwiO1xuaW1wb3J0IHsgYWRqdXN0Q29sbGFwc2UgfSBmcm9tIFwiLi9jb21wb25lbnRzL2NvbGxhcHNlXCI7XG5cblxuZG9jdW1lbnQuYWRkRXZlbnRMaXN0ZW5lcignRE9NQ29udGVudExvYWRlZCcsICgpID0+IHtcblxuICAgIGNvbnN0IGVsZW1lbnRUb1RvcCA9ICcuanMtYmFjay10by10b3AnO1xuICAgIGJhY2tUb1RvcChlbGVtZW50VG9Ub3ApO1xuXG4gICAgaGVhZGVyRml4ZWQodHJ1ZSk7XG5cbiAgICBzZWxlY3RzU3RhdHV0Tm90aWZpY2F0aW9uKGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoXCIuanMtZm9ybS1mdW5lcmFsLWhvdXJcIikpO1xuICAgIHNlbGVjdHNTdGF0dXROb3RpZmljYXRpb24oZG9jdW1lbnQucXVlcnlTZWxlY3RvcihcIi5qcy1mb3JtLWZ1bmVyYWwtbWludXRlXCIpKTtcbiAgICBzZWxlY3RzU3RhdHV0Tm90aWZpY2F0aW9uKGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoXCIuanMtZm9ybS1wbGFubmluZy1kYXlcIikpO1xuXG4gICAgaW5wdXRzU3RhdHV0Tm90aWZpY2F0aW9uKCk7XG4gICAgdmVyaWZTZWxlY3RJbnB1dFN0YXR1dE5vdGlmaWNhdGlvbigpO1xuXG4gICAgZHJvcGRvd25NZW51KCk7XG4gICAgYWRqdXN0Q29sbGFwc2UoJy5kZXNjcmlwdGlvbi10ZXh0Jyk7XG5cbn0sIGZhbHNlKTtcbiJdfQ==
},{"./components/collapse":1,"./components/order":2,"./components/utils":3}],5:[function(require,module,exports){
!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},hasClass:function(e,t){var i=" ";return 1===e.nodeType&&(i+e.className+i).replace(/[\n\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=" "+t},removeClass:function(e,t){var i=new RegExp("\\b"+this.escapeRegExp(t)+"\\b");e.className=e.className.replace(i,"")},interpolateString:function(e,t){return e.replace(/{{([a-z][a-z0-9\-_]*)}}/gi,function(e){return t(arguments[1])||""})},getCookie:function(e){var t=("; "+document.cookie).split("; "+e+"=");return t.length<2?void 0:t.pop().split(";").shift()},setCookie:function(e,t,i,n,o,s){var r=new Date;r.setHours(r.getHours()+24*(i||365));var a=[e+"="+t,"expires="+r.toUTCString(),"path="+(o||"/")];n&&a.push("domain="+n),s&&a.push("secure"),document.cookie=a.join(";")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n=0;if(0===e.length)return n;for(t=0,i=e.length;t<i;++t)n=(n<<5)-n+e.charCodeAt(t),n|=0;return n},normaliseHex:function(e){return"#"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){return e=this.normaliseHex(e),(299*parseInt(e.substr(0,2),16)+587*parseInt(e.substr(2,2),16)+114*parseInt(e.substr(4,2),16))/1e3>=128?"#000":"#fff"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38+(t>>16),n=38+(t>>8&255),o=38+(255&t);return"#"+(16777216+65536*(i<255?i<1?0:i:255)+256*(n<255?n<1?0:n:255)+(o<255?o<1?0:o:255)).toString(16).slice(1)},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return"object"==typeof e&&null!==e&&e.constructor==Object},traverseDOMPath:function(e,i){return e&&e.parentNode?t.hasClass(e,i)?e:this.traverseDOMPath(e.parentNode,i):null}};e.status={deny:"deny",allow:"allow",dismiss:"dismiss"},e.transitionEnd=function(){var e=document.createElement("div"),t={t:"transitionend",OT:"oTransitionEnd",msT:"MSTransitionEnd",MozT:"transitionend",WebkitT:"webkitTransitionEnd"};for(var i in t)if(t.hasOwnProperty(i)&&void 0!==e.style[i+"ransition"])return t[i];return""}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){var n={enabled:!0,container:null,cookie:{name:"cookieconsent_status",path:"/",domain:"",expiryDays:365,secure:!1},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},onNoCookieLaw:function(e,t){},content:{header:"Cookies used on the website!",message:"This website uses cookies to ensure you get the best experience on our website.",dismiss:"Got it!",allow:"Allow cookies",deny:"Decline",link:"Learn more",href:"https://www.cookiesandyou.com",close:"&#x274c;",target:"_blank",policy:"Cookie Policy"},elements:{header:'<span class="cc-header">{{header}}</span>&nbsp;',message:'<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',messagelink:'<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a></span>',dismiss:'<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',allow:'<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',deny:'<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',link:'<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a>',close:'<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'},window:'<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}">\x3c!--googleoff: all--\x3e{{children}}\x3c!--googleon: all--\x3e</div>',revokeBtn:'<div class="cc-revoke {{classes}}">{{policy}}</div>',compliance:{info:'<div class="cc-compliance">{{dismiss}}</div>',"opt-in":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>',"opt-out":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>'},type:"info",layouts:{basic:"{{messagelink}}{{compliance}}","basic-close":"{{messagelink}}{{compliance}}{{close}}","basic-header":"{{header}}{{message}}{{link}}{{compliance}}"},layout:"basic",position:"bottom",theme:"block",static:!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,dismissOnWindowClick:!1,ignoreClicksFrom:["cc-revoke","cc-btn"],autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};function o(){this.initialise.apply(this,arguments)}function s(e){this.openingTimeout=null,t.removeClass(e,"cc-invisible")}function r(t){t.style.display="none",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function a(){var e=this.options.position.split("-"),t=[];return e.forEach(function(e){t.push("cc-"+e)}),t}function c(n){var o=this.options,s=document.createElement("div"),r=o.container&&1===o.container.nodeType?o.container:document.body;s.innerHTML=n;var a=s.children[0];return a.style.display="none",t.hasClass(a,"cc-window")&&e.hasTransition&&t.addClass(a,"cc-invisible"),this.onButtonClick=function(n){var o=t.traverseDOMPath(n.target,"cc-btn")||n.target;if(t.hasClass(o,"cc-btn")){var s=o.className.match(new RegExp("\\bcc-("+i.join("|")+")\\b")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,"cc-close")&&(this.setStatus(e.status.dismiss),this.close(!0));t.hasClass(o,"cc-revoke")&&this.revokeChoice()}.bind(this),a.addEventListener("click",this.onButtonClick),o.autoAttach&&(r.firstChild?r.insertBefore(a,r.firstChild):r.appendChild(a)),a}function l(e){return"000000"==(e=t.normaliseHex(e))?"#222":t.getLuminance(e)}function u(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||"string"==typeof o&&o.length&&o===t)return!0}return!1}return o.prototype.initialise=function(i){this.options&&this.destroy(),t.deepExtend(this.options={},n),t.isPlainObject(i)&&t.deepExtend(this.options,i),function(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;o&&t(n);return o}.call(this)&&(this.options.enabled=!1),u(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),u(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var o=this.options.window.replace("{{classes}}",function(){var i=this.options,n="top"==i.position||"bottom"==i.position?"banner":"floating";t.isMobile()&&(n="floating");var o=["cc-"+n,"cc-type-"+i.type,"cc-theme-"+i.theme];i.static&&o.push("cc-static");o.push.apply(o,a.call(this));(function(i){var n=t.hash(JSON.stringify(i)),o="cc-color-override-"+n,s=t.isPlainObject(i);this.customStyleSelector=s?o:null,s&&function(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+".cc-window"]=["color: "+r.text,"background-color: "+r.background],s[o+".cc-revoke"]=["color: "+r.text,"background-color: "+r.background],s[o+" .cc-link,"+o+" .cc-link:active,"+o+" .cc-link:visited"]=["color: "+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:"transparent",s[o+" .cc-btn"]=["color: "+a.text,"border-color: "+a.border,"background-color: "+a.background],a.padding&&s[o+" .cc-btn"].push("padding: "+a.padding),"transparent"!=a.background&&(s[o+" .cc-btn:hover, "+o+" .cc-btn:focus"]=["background-color: "+(a.hover||l(a.background))]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:"transparent",s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+c.text,"border-color: "+c.border,"background-color: "+c.background]):s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+r.text]));var u=document.createElement("style");document.head.appendChild(u),e.customStyles[i]={references:1,element:u.sheet};var h=-1;for(var p in s)s.hasOwnProperty(p)&&u.sheet.insertRule(p+"{"+s[p].join(";")+"}",++h)}(n,i,"."+o);return s}).call(this,this.options.palette);this.customStyleSelector&&o.push(this.customStyleSelector);return o}.call(this).join(" ")).replace("{{children}}",function(){var e={},i=this.options;i.showLink||(i.elements.link="",i.elements.messagelink=i.elements.message);Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&"string"==typeof t&&t.length?t:""})});var n=i.compliance[i.type];n||(n=i.compliance.info);e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];o||(o=i.layouts.basic);return t.interpolateString(o,function(t){return e[t]})}.call(this)),s=this.options.overrideHTML;if("string"==typeof s&&s.length&&(o=s),this.options.static){var r=c.call(this,'<div class="cc-grower">'+o+"</div>");r.style.display="",this.element=r.firstChild,this.element.style.display="none",t.addClass(this.element,"cc-invisible")}else this.element=c.call(this,o);(function(){var i=this.setStatus.bind(this),n=this.close.bind(this),o=this.options.dismissOnTimeout;"number"==typeof o&&o>=0&&(this.dismissTimeout=window.setTimeout(function(){i(e.status.dismiss),n(!0)},Math.floor(o)));var s=this.options.dismissOnScroll;if("number"==typeof s&&s>=0){var r=function(t){window.pageYOffset>Math.floor(s)&&(i(e.status.dismiss),n(!0),window.removeEventListener("scroll",r),this.onWindowScroll=null)};this.options.enabled&&(this.onWindowScroll=r,window.addEventListener("scroll",r))}var a=this.options.dismissOnWindowClick,c=this.options.ignoreClicksFrom;if(a){var l=function(o){for(var s=!1,r=o.path.length,a=c.length,u=0;u<r;u++)if(!s)for(var h=0;h<a;h++)s||(s=t.hasClass(o.path[u],c[h]));s||(i(e.status.dismiss),n(!0),window.removeEventListener("click",l),window.removeEventListener("touchend",l),this.onWindowClick=null)}.bind(this);this.options.enabled&&(this.onWindowClick=l,window.addEventListener("click",l),window.addEventListener("touchend",l))}}).call(this),function(){"info"!=this.options.type&&(this.options.revokable=!0);t.isMobile()&&(this.options.animateRevokable=!1);if(this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push("cc-animate"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace("{{classes}}",e.join(" ")).replace("{{policy}}",this.options.content.policy);this.revokeBtn=c.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=window.innerHeight-20;t.hasClass(n,"cc-top")&&e.clientY<20&&(i=!0),t.hasClass(n,"cc-bottom")&&e.clientY>o&&(i=!0),i?t.hasClass(n,"cc-active")||t.addClass(n,"cc-active"):t.hasClass(n,"cc-active")&&t.removeClass(n,"cc-active")},200);this.onMouseMove=o,window.addEventListener("mousemove",o)}}}.call(this),this.options.autoOpen&&this.autoOpen()},o.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener("click",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener("scroll",this.onWindowScroll),this.onWindowScroll=null),this.onWindowClick&&(window.removeEventListener("click",this.onWindowClick),this.onWindowClick=null),this.onMouseMove&&(window.removeEventListener("mousemove",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,function(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}(this.options.palette),this.options=null},o.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display="",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},o.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display="none",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},o.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&r.call(this,i),t.hasClass(i,"cc-invisible"))){if(i.style.display="",this.options.static){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+"px"}this.openingTimeout=setTimeout(s.bind(this,i),20)}},o.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),s.bind(this,i)),t.hasClass(i,"cc-invisible")||(this.options.static&&(this.element.parentNode.style.maxHeight=""),this.afterTransition=r.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,"cc-invisible")))},o.prototype.isOpen=function(){return this.element&&""==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,"cc-invisible"))},o.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?"":"none")},o.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},o.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},o.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},o.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled?this.open():this.hasAnswered()&&this.options.revokable&&this.toggleRevokeButton(!0)},o.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path,n.secure),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},o.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},o.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,"",-1,e.domain,e.path)},o}(),e.Location=function(){var e={timeout:5e3,services:["ipinfo"],serviceDefinitions:{ipinfo:function(){return{url:"//ipinfo.io",headers:["Accept: application/json"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?s(i):{code:i.country}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},ipinfodb:function(e){return{url:"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return"ERROR"==i.statusCode?s({error:i.statusMessage}):{code:i.countryCode}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},maxmind:function(){return{url:"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",isScript:!0,callback:function(e){window.geoip2?geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(t){e(s(t))}},function(t){e(s(t))}):e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"))}}}}};function i(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i),this.currentServiceIndex=-1}function n(e,t,i){var n,o=document.createElement("script");o.type="text/"+(e.type||"javascript"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function o(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)("MSXML2.XMLHTTP.3.0");if(s.open(n?"POST":"GET",e,1),s.setRequestHeader("Content-type","application/x-www-form-urlencoded"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(":",2);s.setRequestHeader(c[0].replace(/^\s+|\s+$/g,""),c[1].replace(/^\s+|\s+$/g,""))}"function"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function s(e){return new Error("Error ["+(e.code||"UNKNOWN")+"]: "+e.error)}return i.prototype.getNextService=function(){var e;do{e=this.getServiceByIdx(++this.currentServiceIndex)}while(this.currentServiceIndex<this.options.services.length&&!e);return e},i.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if("function"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return"string"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},i.prototype.locate=function(e,t){var i=this.getNextService();i?(this.callbackComplete=e,this.callbackError=t,this.runService(i,this.runNextServiceOnError.bind(this))):t(new Error("No services to run"))},i.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\{(.*?)\}/g,function(i,n){if("callback"===n){var o="callback"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},i.prototype.runService=function(e,t){var i=this;e&&e.url&&e.callback&&(e.isScript?n:o)(this.setupUrl(e),function(n){var o=n?n.responseText:"";e.__JSONP_DATA&&(o=e.__JSONP_DATA,delete e.__JSONP_DATA),i.runServiceCallback.call(i,t,e,o)},this.options.timeout,e.data,e.headers)},i.prototype.runServiceCallback=function(e,t,i){var n=this,o=t.callback(function(t){o||n.onServiceResult.call(n,e,t)},i);o&&this.onServiceResult.call(this,e,o)},i.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},i.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error("All services failed"))}else this.completeService.call(this,this.callbackComplete,t)},i.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return"string"==typeof e?{name:e}:"function"==typeof e?e():t.isPlainObject(e)?e:{}},i.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},i.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.warn("The service["+t+"] ("+i.url+") responded with the following error",e)},i}(),e.Law=function(){var e={regionalLaw:!0,hasLaw:["AT","BE","BG","HR","CZ","CY","DK","EE","FI","FR","DE","EL","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","SK","ES","SE","GB","UK","GR","EU"],revokable:["HR","CY","DK","EE","FR","DE","LV","LT","NL","PT","ES"],explicitAction:["HR","IT","ES"]};function i(e){this.initialise.apply(this,arguments)}return i.prototype.initialise=function(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i)},i.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},i.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1,"function"==typeof e.onNoCookieLaw&&e.onNoCookieLaw(t,i)),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},i}(),e.initialise=function(i,n,o){var s=new e.Law(i.law);n||(n=function(){}),o||(o=function(){});var r=Object.keys(e.status),a=t.getCookie("cookieconsent_status");r.indexOf(a)>=0?n(new e.Popup(i)):e.getCountryCode(i,function(t){delete i.law,delete i.location,t.code&&(i=s.applyLaw(i,t.code)),n(new e.Popup(i))},function(t){delete i.law,delete i.location,o(t,new e.Popup(i))})},e.getCountryCode=function(t,i,n){t.law&&t.law.countryCode?i({code:t.law.countryCode}):t.location?new e.Location(t.location).locate(function(e){i(e||{})},n):i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});
},{}],6:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

},{}]},{},[4])